import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  selectSelectedTake3D,
  updateSelectedTake,
  updateSelectedTakeProperty,
} from "../../app/slices/TrainingSlice";
import { InteractionProperty } from "../../models/InteractionProperty";
import Take3D from "../../models/Take3D";
import Interaction from "../../models/interactions/Interaction";
import InteractionPropertyView from "../interaction_properties_column/InteractionPropertyView";
import { InstantSpeedProperties } from "../interaction_properties_column/editors/InstantSpeedPropertiesEditor";
import TakeStartingViewField from "./TakeStartingViewField";
import EditorColumn, {
  EditorColumnFieldGroup,
  EditorColumnHeader,
  EditorColumnSection,
} from "../editor_columns/EditorColumn";

export default function Take3DCameraPropertiesColumn() {
  const dispatch = useDispatch();
  const take = useSelector(selectSelectedTake3D);
  const { t } = useTranslation();

  const onChange = (interactionProperty: InteractionProperty) => {
    dispatch(updateSelectedTakeProperty(interactionProperty));
  };

  const updateCamera = (camera: Interaction) => {
    if (!take) return;
    const updatedTake: Take3D = {
      ...take,
      mainCamera: { ...take.mainCamera, ...camera },
    };
    dispatch(updateSelectedTake(updatedTake));
  };

  const storyProp = take?.properties?.find((p) => p.id === "isStory");
  const storyView = storyProp ? (
    <InteractionPropertyView
      interactionProperty={storyProp}
      onChange={onChange}
    />
  ) : (
    <></>
  );

  return (
    <EditorColumn
      testId="take3d-camera-properties-column"
      widthClassName="w-full min-w-0"
      borderSide="left"
      header={
        <EditorColumnHeader
          icon={<CameraAltOutlinedIcon fontSize="inherit" />}
          title={t("take_starting_view", "Starting view")}
          testId="take3d-camera-properties-header"
        />
      }
    >
      {take && (
        <EditorColumnSection
          title={t("take_starting_view", "Starting view")}
          icon={<CameraAltOutlinedIcon fontSize="inherit" />}
          defaultExpanded
          testId="take3d-camera-properties-section"
        >
          <EditorColumnFieldGroup>
            <TakeStartingViewField take={take} />
            {storyView}
            <InstantSpeedProperties
              interaction={take.mainCamera}
              showBehaviorLabel={false}
              onChange={(property) =>
                updateCamera({
                  ...take.mainCamera,
                  properties: take.mainCamera.properties?.map((existing) =>
                    existing.id === property.id ? property : existing
                  ),
                })
              }
            />
          </EditorColumnFieldGroup>
        </EditorColumnSection>
      )}
    </EditorColumn>
  );
}
